"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const Dashboard_1 = __importDefault(require("../class/models/Dashboard"));
const floating_vue_1 = require("floating-vue");
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let ListDeliverables = class ListDeliverables extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.selected = 0;
        this.eventTracker = new EventTracker_1.default();
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    emitProject(p) {
        this.$emit('projectSelected', p);
    }
    emitSample(p) {
        this.$emit('sampleSelected', p);
    }
    emitFilter(filter) {
        this.selected = 0;
        this.emitProject(this.lastProjects[0]);
        this.emitSample(this.lastSamples[0]);
        this.$emit('filter', filter);
        this.eventTrackerListener('filterDashboard', { filter: filter });
    }
    rediret() {
        window.location.href = '/results/projects';
        this.eventTrackerListener('viewAllProjects', true);
    }
    rediretSamples() {
        window.location.href = '/reports';
        this.eventTrackerListener('viewAllSamples', true);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new Dashboard_1.default() })
], ListDeliverables.prototype, "dataset", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], ListDeliverables.prototype, "lastProjects", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], ListDeliverables.prototype, "lastSamples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], ListDeliverables.prototype, "projectsTypes", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], ListDeliverables.prototype, "samplesCrops", void 0);
ListDeliverables = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            List: bmk_ui_framework_1.List,
            ListItem: bmk_ui_framework_1.ListItem,
            Tag: bmk_ui_framework_1.Tag,
            Select: bmk_ui_framework_1.Select,
            DateStylized: bmk_ui_framework_1.DateStylized,
            Dropdown: floating_vue_1.Dropdown,
        },
    })
], ListDeliverables);
exports.default = ListDeliverables;
